import { Chat } from './src/modules/Chat';
import { Email } from './src/modules/Email';
import { Hours } from './src/modules/Hours';
import { Stats } from './src/modules/Stats';
import { Numbers } from './src/modules/Shared/Numbers';
import { Utilites } from './src/modules/Shared/Utilities';
import { UserInfo } from './src/modules/UserInfo';
import { Analytics } from './src/modules/analytics';
import polyfill from './node_modules/element-dataset/lib/browser/index.cjs';
import jump from './node_modules/jump.js';

polyfill();

new Numbers();

const util = new Utilites(false);
const environment = util.environment();
// set customerSegment (Employee,agent_broker)
const customerSegment = document.getElementById('chat-customerSegment').value;

// *** call functions *** //
// update open hours based on producer or employee
let hourSettings;
if(customerSegment !== 'Employee') {
    hourSettings = {
        url: 'https://' + environment.moo + '.mutualofomaha.com/api/genesys/calendar/call/producerTS'
    };
} else {
    hourSettings = {
        url: 'https://' + environment.moo + '.mutualofomaha.com/api/genesys/calendar/call/serviceDesk'
    };
}

const hoursCall = new Hours(hourSettings);
const hourData = hoursCall.getHours();
// show - hide after hours information if unavailable
hourData.then((resp) => {
    if(resp.open_for !== '00:00:00') {
        util.removeClass('.open-Hours', 'core-u-hidden');
    } else {
        util.removeClass('.closed-Hours', 'core-u-hidden');
    }
});


// *** chat functions *** //
let hourSettingsChat;
if(customerSegment !== 'Employee') {
    hourSettingsChat = {
        url: 'https://' + environment.moo + '.mutualofomaha.com/api/genesys/calendar/chat/producerTS'
    };
} else {
    hourSettingsChat = {
        url: 'https://' + environment.moo + '.mutualofomaha.com/api/genesys/calendar/chat/serviceDesk'
    };
}

const hoursChat = new Hours(hourSettingsChat);
const hourDataChat = hoursChat.getHours();
// show - hide after hours information and form if unavailable
// set chat status as open or closed. used in statData below to toggle if open, but not agents logged in
let chat_stat;
hourDataChat.then((resp) => {
    if(resp.open_for !== '00:00:00') {
        util.removeClass('.open-HoursChat', 'core-u-hidden');
        chat_stat = 'open';
    } else {
        util.removeClass('.closed-HoursChat', 'core-u-hidden');
        util.addClass('#chat-Form', 'core-u-hidden');
        chat_stat = 'closed';
    }
});
// set customer and form information for chat
const chatForm = document.getElementById('chat-Form');
const chatSettings = {
    url: 'https://' + environment.moo + '.mutualofomaha.com/genesys/chat',
    segment: document.getElementById('chat-customerSegment').value
};
const chattery = new Chat(chatForm, chatSettings);
// open chat window
chattery.popup(document.getElementById('start-chat'));


// *** stat functions *** //
const statSettings = {
    url: 'https://' + environment.moo + '.mutualofomaha.com/api/genesys/statistics'
};
const statistics = new Stats(statSettings);
// round time to minute
const roundTime = function(seconds, timeToRound = 0) {
    const minutes = Math.round((seconds!==0) ? seconds/60 : 1);
    return (Math.round(minutes/timeToRound) * timeToRound) % 60;
};
// set estimated time for availability

for(let elem of Array.from(document.getElementsByClassName('call-stats'))) {

    const timeRound = 1;
    let count = 0;
    let statData;
    elem.addEventListener('click', () => {

        util.addClass(
            '.tech-EstimatedTime, .tech-SupportAvailable',
            'core-u-hidden'
        );
        if(elem.dataset['contactType'] === 'clickToCall') {
            statData = statistics.getStats('vag_Assistance_Center');
        } else {
            statData = statistics.getStats('vag_ASC_ProducerTS_Chat');
        }

        statData.then((resp) => {
            if(resp.currEWT === 0 && resp.CurrentReadyAgents === 0) {
                count = roundTime(resp.AverHandleTime, timeRound);
            } else {
                count = roundTime(resp.currEWT, timeRound);
            }
            // if technical support add estimated time
            if(elem.dataset['supportType'] === 'technical-Support') {
                for (let element of Array.from(document.getElementsByClassName('tech-Support-EstimatedTime'))) {
                    element.innerHTML = count;
                    util.removeClass(
                        '.tech-EstimatedTime',
                        'core-u-hidden'
                    )
                }
            }
            // hide chat form if open but no agents are logged in
            if((chat_stat === 'open')&&(resp.CurrAgentsLoggedIn) === 0) {
                util.addClass('#chat-Form', 'core-u-hidden');
                util.addClass('#chatSupport .tech-EstimatedTime', 'core-u-hidden')
                util.removeClass(
                    '.no-AgentsChat',
                    'core-u-hidden'
                )
            }
        });
    });
}


// *** email functions *** //
const emailForm = document.getElementById('email-Form');
const emailSettings = {
    url: document.getElementById('emailUrl').value,
    segment: document.getElementById('email-customerSegment').value
};
const emails = new Email(emailForm, emailSettings);
//
if(typeof userInfo !== 'undefined') {
    const userInfoUrl = 'https://' + environment.moo + '.mutualofomaha.com/api/producer-demographics/demographics/';
    new UserInfo(chatForm, userInfo, userInfoUrl);
    new UserInfo(emailForm, userInfo, userInfoUrl);
}
// send messages
emails.send(document.getElementById('send-message'));


// *** page interaction functions *** //
// init page sections
const supportType = Array.from(document.getElementsByClassName('portal-supportType'));
const contactType = Array.from(document.getElementsByClassName('contact-SectionType'));
// init anlytics
const analytics = new Analytics();
// show hide support type (sales, tech, etc.)
for(let type of supportType) {
    type.addEventListener('click', () => {

        util.addClass(
            '.contact-Section, .hours, .contact-Type',
            'core-u-hidden'
        );
        util.removeClass(
            '.portal-supportType, .contact-SectionType',
            'is-active'
        );
        //
        if(type.dataset['supportId'] === 'dxd-Support') {
            util.removeClass(
                '#emailSupport, .' + type.dataset['supportId'],
                'core-u-hidden'
            );
            util.addClass('.sales-tech-Support', 'core-u-hidden');
            document.getElementById('email-type').value = type.dataset['supportId'];
        } else {
            util.removeClass(
                '.sales-tech-Support, .' + type.dataset['supportId'] + ',.' + type.dataset['contactType'] + ',#' + type.dataset['contactType'],
                'core-u-hidden'
            );
        }
        //
        for(let k in type.dataset) {
            if(typeof emailForm[k] !== 'undefined') {
                document.getElementById(k).value = type.dataset[k];
            }
        }

        analytics.trackEvent({'category':'Support Type','action':'click','label':type.dataset['supportId']});
        type.classList.add('is-active');
        jump('#' + type.dataset['contactType']);
    });
}
// show hide contact type (call, chat, email, etc.);
for(let cType of contactType) {
    cType.addEventListener('click', () => {

        util.removeClass(
            '.contact-SectionType',
            'is-active'
        );
        util.addClass(
            '.contact-Type',
            'core-u-hidden'
        );
        util.removeClass(
            '#' + cType.dataset['contactType'],
            'core-u-hidden'
        );

        document.getElementById('email-type').value = cType.dataset['supportType'];
        analytics.trackEvent({'category':cType.dataset['supportType'],'action':'click','label':cType.dataset['contactType']});
        cType.classList.add('is-active');
        jump('#' + cType.dataset['contactType']);
    });
}



// WEBPACK FOOTER //
// ./app.js